<template>
  <h1 tabindex="0" class="pageHeader">Revocation/Watchlist</h1>

  <DataTableComponent 
  v-if="this.getAllUrl" 
  :data-url="this.getAllUrl" 
  :column-list-d-b="this.personDataColumnNames"
  :column-list-pretty="this.personDataColumnNamesPretty" 
  :order-column-index="0" 
  :date-column-indexes="[3]"
  :rows-per-page="-1" 
  :show-search="true" 
  plural-data-name="people"
  order-direction="asc" 
  ref="personsDatatable"
  :show-action-column="false"
  :show-paging="false"
  >

  </DataTableComponent>

</template>

<script>

import DataTableComponent from "@/components/dataSupport/DataTable.vue";
import { store } from "@/store/store.js";

export default {
  components: {
    DataTableComponent,

  },
  data() {
    return{
      getAllUrl:null,
    store,
    personDataColumnNames: ['contractNumber','lastName', 'firstName','personUpdateDatePretty'],
    personDataColumnNamesPretty: ['List','Last Name', 'First Name','Revocation Date'],
    }
   
  },
  created() {
    this.getAllUrl = store.webAPIUrl + "people/getWatchlist/";
  },
  computed: {},
  methods: {},
};
</script>

<style scoped>

    .pageHeader {
        font-size: 24px;
        color: #000099;
    }

</style>
